import { ClipboardList, ChevronsRight } from "lucide-react";

export const profileSeps = [
  { id: 'personal', title: "Personal Information", description: 'Name, address & emergency contact', color: 'bg-blue-100 text-blue-500', heading: 'Start with Personal Information', time: '2 min' },
  { id: 'insurance', title: "Insurance", description: 'Carrier, member details & card', color: 'bg-green-100 text-green-600', heading: 'Next up: Insurance', time: '1 min' },
  { id: 'medical', title: "Medical", description: 'Allergies, conditions & medications', color: 'bg-purple-100 text-purple-500', heading: 'Next up: Medical History', time: '2 min' },
  { id: 'consent', title: "Consent", description: 'Review & agree to required forms', color: 'bg-amber-100 text-amber-600', heading: 'Next up: Consent Forms', time: '1 min' },
  { id: 'preferences', title: "Preferences", description: 'Appointment & contact preferences', color: 'bg-indigo-100 text-indigo-500', heading: 'Next up: Preferences', time: '30 sec' }
];

export const pageHeadings = (stepId) => {
  if (stepId == "personal")
    return {
      pageHeading: "Let's get your paperwork done",
      pageSubHeading: "Finish these before your visit and check-in takes seconds.",
      btnTitle: 'Start my forms',
      info: 'Five short forms, about six minutes. Everything saves as you go.',
      icon: ClipboardList,
      className: { bg: 'bg-blue-50 border-blue-100', icon: 'bg-blue-100 text-blue-500' }
    }
  else
    return {
      pageHeading: "Profile & Forms",
      pageSubHeading: "Keep these current so check-in says quick",
      btnTitle: 'Continue where I left off',
      info: 'Pick up where you left off and finish the rest in order.',
      icon: ChevronsRight,
      className: { bg: 'bg-secondary-50/50 border-secondary-200/70', icon: 'bg-white text-green-500 border-secondary-200/70 border' }
    }
}

export const getNextIncompleteStep = (completion) => {
  return profileSeps.find((s) => !completion[s.id])
}

export const getNumberOfCompletedStep = (completion) => {
  let completed = 0
  profileSeps.forEach((step) => (completion[step.id] ? completed += 1 : null))
  return completed
}
